export default {
    BOX: 'box',
  }
  